module.exports = __webpack_public_path__ + "media/images/icon_eye_full_dark-21fb74b578ed703410cc0cb4861f580c.svg";